import {Component, Injector, OnInit} from '@angular/core';
import {FiltroHotel} from 'src/app/core/viewModel/filtro_hotel.model';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AppComponent} from 'src/app/app.component';
import {BaseComponents} from '../../shared/base-components';
import {
    ALL_INCLUSIVE,
    CAFE_MANHA,
    FAZENDA,
    FLAT,
    HOTEL,
    MEIA_PENSAO,
    MEIA_PENSAO_ALMOCO,
    MEIA_PENSAO_JANTAR,
    PENSAO_COMPLETA,
    POUSADA,
    RESORT
} from '../../app.constants';
import {CategoriaPlanoService} from '../../core/services/categoria_plano.service';
import {HotelService} from '../../core/services/hotel.service';
import {Meta, Title} from '@angular/platform-browser';
import {TYPE_META} from '../../core/constants/meta_title.constant';

export interface IItemResultFiltros {
    id: string;
    descricao: string;
    quantidade: number;
}
export interface IResultFiltros {
    0: string;
    1: {
        descricao: string;
        quantidade: number;
        itens: IItemResultFiltros[]
    };
}
@Component({
    selector: 'app-lista-hoteis',
    templateUrl: './lista-hoteis.component.html',
    styleUrls: ['./lista-hoteis.component.sass']
})
export class ListaHoteisComponent extends  BaseComponents implements OnInit {

    resultHoteis: any;
    hoteisSite: any = [];
    paginacao: any = [];
    paginaAtual: number;
    inicioPaginacao: number;
    fimPaginacao: number;
    pesquisa: string;
    resultFiltros: FiltroHotel;
    countFiltrosSelecionados = 0;
    filtro: any;
    queryTipoComodidade: any;
    queryHotel: any;
    queryTipoHotel: any;
    queryTipoQuarto: any;
    queryTipoApartamento: any;
    queryCodCidade: any;
    queryCodEstado: any;
    queryCodPais: any;
    queryCodBairro: any;
    queryTipoPlano: any;
    queryRegimeAlimentacao: any;
    queryCriancaGratis: any;
    dataAutoComplete: any;
    qtdPorPagina: number;
    showFilter = false;
    constructor(
        protected injector: Injector,
        public hotelService: HotelService,
        private route: ActivatedRoute,
        protected router: Router,
        private appComponent: AppComponent,
        private categoriaPlanoService: CategoriaPlanoService,
        protected titleService: Title,
        protected meta: Meta) {
        super(injector);
    }

    async ngOnInit() {
        super.ngOnInit();
        window.open('https://montrealviagens.my.site.com/listagemhoteis/s/', '_top');
        this.setMetaTitle(TYPE_META.BUSCA_HOTEIS);
        this.qtdPorPagina = 15;
        this.loadQuery();
        this.initQueryParams();
        await this.loadPage();
    }

    initQueryParams() {
        const queryParams = this.route.snapshot.queryParams;
        if (queryParams) {
            const query = this.convertQueryParams(queryParams);
            localStorage.setItem('montreal.busca-hotel.queryParams', query);
            return;
        }
        localStorage.setItem('montreal.busca-hotel.queryParams', null);
    }
    getInitQueryParams() {
        return  localStorage.getItem('montreal.busca-hotel.queryParams');
    }
    async atualizaCountFiltrosSelecionados(body) {
        this.countFiltrosSelecionados = await this.hotelService.getCountFiltrosSelecionados(body);
    }

    loadQuery() {
        this.queryTipoComodidade = this.route.snapshot.queryParams.tipoComodidade;
        this.queryTipoApartamento = this.route.snapshot.queryParams.tipoApartamento;
        this.queryCodCidade = this.route.snapshot.queryParams.codCidade;
        this.queryCodEstado = this.route.snapshot.queryParams.codEstado;
        this.queryCodPais = this.route.snapshot.queryParams.codPais;
        this.queryCodBairro = this.route.snapshot.queryParams.codBairro;
        this.queryTipoPlano = this.route.snapshot.queryParams.tipoPlano;
        this.queryRegimeAlimentacao = this.route.snapshot.queryParams.regimeAlimentacao;
        this.queryTipoHotel = this.route.snapshot.queryParams.tipoHotel;
        this.queryTipoQuarto = this.route.snapshot.queryParams.tipoQuarto;
        this.queryHotel = this.route.snapshot.queryParams.hotel;
        this.queryCriancaGratis = this.route.snapshot.queryParams.criancaGratis;
        this.dataAutoComplete = JSON.parse(localStorage.getItem('auto-complete-data'));
    }

    loadFilterTipoPlano() {
        const data = [];
        let codigo = this.categoriaPlanoService.getCodigoPlanoPorNome(this.queryTipoPlano.toUpperCase());
        if (codigo) {
            const split = codigo.split('');
            if (split[0] === '0') {
                codigo = split[1];
            }
            data.push(codigo);
        }
        return data;
    }

    private loadFilterRegimeAlimentacao() {
        const data = [];
        switch (this.queryRegimeAlimentacao.toUpperCase()) {
            case ALL_INCLUSIVE:
                data.push(this.queryRegimeAlimentacao.toUpperCase());
                break;
            case MEIA_PENSAO_ALMOCO:
                data.push(this.queryRegimeAlimentacao.toUpperCase());
                break;
            case MEIA_PENSAO_JANTAR:
                data.push(this.queryRegimeAlimentacao.toUpperCase());
                break;
            case CAFE_MANHA:
                data.push(this.queryRegimeAlimentacao.toUpperCase());
                break;
            case PENSAO_COMPLETA:
                data.push(this.queryRegimeAlimentacao.toUpperCase());
                break;
            case MEIA_PENSAO:
                data.push(this.queryRegimeAlimentacao.toUpperCase());
                break;
            default:
                break;
        }
        return data;
    }

    private loadFilterTipoHotel() {
        const data = [];
        switch (this.queryTipoHotel.toUpperCase()) {
            case FLAT.value:
                data.push(FLAT.id);
                break;
            case RESORT.value:
                data.push(RESORT.id);
                break;
            case FAZENDA.value:
                data.push(FAZENDA.id);
                break;
            case POUSADA.value:
                data.push(POUSADA.id);
                break;
            case HOTEL.value:
                data.push(HOTEL.id);
                break;
            default:
                break;
        }
        return data;
    }

    private loadFilterTipoQuarto() {
        const data = [];
        switch (this.queryTipoQuarto.toLowerCase()) {
            case 'dbl,tpl':
                data.push('dbl');
                data.push('tpl');
                break;
            case 'tpl,dbl':
                data.push('dbl');
                data.push('tpl');
                break;
            case 'dbl':
                data.push('dbl');
                break;
            case 'tpl':
                data.push('tpl');
                break;
            default:
                break;
        }
        return data;
    }

    private loadFilterHotel() {
        const data = [];
        switch (this.queryHotel.toUpperCase()) {
            case 'NACIONAL':
                data.push('1');
                break;
            case 'INTERNACIONAL':
                data.push('2');
                break;
            default:
                break;
        }
        return data;
    }

    private loadFilterCriancaGratis() {
        const data = [];
        if (this.queryCriancaGratis.toUpperCase() === 'sim') {
            data.push('1');
        }
        return data;
    }

    loadQueryFiltro(filtro: any) {
        if (this.queryCodPais) {
            filtro.codPais = this.queryCodPais;
        } else if (this.queryCodEstado) {
            filtro.codEstado = this.queryCodEstado;
        } else if (this.queryCodCidade) {
            filtro.codCidade = this.queryCodCidade;
        } else if (this.queryCodBairro) {
            filtro.codBairro = this.queryCodBairro;
            filtro.bairro = this.queryCodBairro;
        }
        if (this.queryTipoPlano) {
            filtro.tipoPlano = this.loadFilterTipoPlano();
        }
        if (this.queryRegimeAlimentacao) {
            filtro.regimesAlimentacao = this.loadFilterRegimeAlimentacao();
            filtro.regimeAlimentacao = filtro.regimesAlimentacao;
        }
        if (this.queryTipoHotel) {
            filtro.tipoHotel = this.loadFilterTipoHotel();
        }
        if (this.queryTipoQuarto) {
            filtro.tipoQuarto = this.loadFilterTipoQuarto();
        }
        if (this.queryHotel) {
            filtro.hotel = this.loadFilterHotel();
        }
        if (this.queryCriancaGratis) {
            filtro.criancaGratis = this.loadFilterCriancaGratis();
        }
        return filtro;
    }

    loadQueryFiltroAutoComplete() {
        const filtro: any = { numeroPagina: 1, qtdPorPagina: this.qtdPorPagina };
        if (this.queryCodPais) {
            filtro.codPais = this.queryCodPais;
        } else if (this.queryCodEstado) {
            filtro.codEstado = this.queryCodEstado;
        } else if (this.queryCodCidade) {
            filtro.codCidade = this.queryCodCidade;
        } else if (this.queryCodBairro) {
            filtro.codBairro = this.queryCodBairro;
        } else if (this.dataAutoComplete.tipo === 'paises') {
            filtro.codPais = this.dataAutoComplete.data.id;
        } else if (this.dataAutoComplete.tipo === 'estados') {
            filtro.codEstado = this.dataAutoComplete.data.id;
        } else if (this.dataAutoComplete.tipo === 'cidades') {
            filtro.codCidade = this.dataAutoComplete.data.id;
        } else if (this.dataAutoComplete.tipo === 'bairros') {
            filtro.bairro = this.dataAutoComplete.data.nome;
        }
        if (this.queryTipoPlano) {
            filtro.tipoPlano = this.loadFilterTipoPlano();
        }
        if (this.queryRegimeAlimentacao) {
            filtro.regimesAlimentacao = this.loadFilterRegimeAlimentacao();
            filtro.regimeAlimentacao = filtro.regimesAlimentacao;
        }
        if (this.queryTipoHotel) {
            filtro.tipoHotel = this.loadFilterTipoHotel();
        }
        if (this.queryTipoQuarto) {
            filtro.tipoQuarto = this.loadFilterTipoQuarto();
        }
        if (this.queryHotel) {
            filtro.hotel = this.loadFilterHotel();
        }
        if (this.queryCriancaGratis) {
            filtro.criancaGratis = this.loadFilterCriancaGratis();
        }
        return filtro;
    }

    resultHoteisSite() {
        if (this.resultHoteis && this.resultHoteis.data) {
            this.hoteisSite = this.resultHoteis.data.hoteis;
        } else {
            this.hoteisSite = null;
        }
    }

    public async loadPage() {
        this.appComponent.showOverlay();
        this.inicioPaginacao = 1;
        this.fimPaginacao = 1;
        this.appComponent.hideOverlay();
        if (this.queryCodCidade || this.queryCodEstado || this.queryCodPais || this.queryCodBairro) {
            await this.loadHoteisPorAutoComplete();
        } else if (this.queryTipoComodidade) {
            await this.loadHoteisPorTipoComodidade(this.queryTipoComodidade);
        } else if (this.queryTipoApartamento) {
            await this.loadHoteisPorTipoApartamento(this.queryTipoApartamento);
        } else {
            await this.loadHoteis();
        }
        await this.loadFiltros(1, this.qtdPorPagina);
        this.appComponent.hideOverlay();
    }

    async loadHoteis() {
        this.appComponent.showOverlay();
        this.filtro = { numeroPagina: 1, qtdPorPagina: this.qtdPorPagina };
        if (this.queryTipoPlano) {
            this.filtro.tipoPlano = this.loadFilterTipoPlano();
        }
        if (this.queryRegimeAlimentacao) {
            this.filtro.regimesAlimentacao = this.loadFilterRegimeAlimentacao();
            this.filtro.regimeAlimentacao = this.filtro.regimesAlimentacao;
        }
        if (this.queryTipoHotel) {
            this.filtro.tipoHotel = this.loadFilterTipoHotel();
        }
        if (this.queryTipoQuarto) {
            this.filtro.tipoQuarto = this.loadFilterTipoQuarto();
        }
        if (this.queryHotel) {
            this.filtro.hotel = this.loadFilterHotel();
        }
        if (this.queryCriancaGratis) {
            this.filtro.criancaGratis = this.loadFilterCriancaGratis();
        }
        this.resultHoteis = await this.hotelService.listaHoteis(this.filtro);
        this.hoteisSite = this.resultHoteis.data.hoteis;
        this.paginaAtual = this.resultHoteis.data.numeroPagina;

        this.carregaPaginacao();

        this.appComponent.hideOverlay();
    }

    async loadFiltros(paramNumeroPagina, paramQtdPorPagina) {
        if (!this.filtro) {
            this.filtro = { numeroPagina: paramNumeroPagina, qtdPorPagina: paramQtdPorPagina };
        }
        const result = await this.hotelService.filtroAvancado(this.filtro);
        this.resultFiltros = this.cleanFilter(this.tratarFiltro(this.hotelService.ordernarPlanosFacilita(result.data)));
    }

     tratarFiltro(filtro: any) {
        if (filtro.tipoPlano.quantidade === 1) {
            filtro.tipoPlano.itens.forEach(plano => plano.checked = true);
        }
        if (filtro.regimesAlimentacao.quantidade === 1) {
            filtro.regimesAlimentacao.itens.forEach(regime => regime.checked = true);
        }
        if (filtro.hotel.quantidade === 1) {
            filtro.hotel.itens.forEach(hotel => hotel.checked = true);
        }
        if (this.queryCriancaGratis) {
            filtro.criancaGratis.itens.forEach(criancaGratis => criancaGratis.checked = true);
        }
        return filtro;
    }

    async loadHoteisAvancado() {
        this.appComponent.showOverlay();
        this.paginaAtual = 1;
        const loadFiltrosTratados = await this.loadFiltrosTratados();
        this.resultHoteis = await this.hotelService.listaHoteisAvancado(this.filtro, this.resultFiltros);
        this.resultHoteisSite();
        const filtrosTratados = loadFiltrosTratados.filtrosTratados;
        const result = loadFiltrosTratados.result;
        this.resultFiltros = this.cleanFilter(result.data);
        await this.atualizaCountFiltrosSelecionados(filtrosTratados);
        this.carregaPaginacao();
        this.setFilterQueryParams(this.route.snapshot.queryParams);
        this.appComponent.hideOverlay();
    }

    setFilterQueryParams(queryParams: Params) {
        const query = {
            ...queryParams
        };
        const filtroAvancado = this.hotelService.getFiltroAvancado(this.filtro, this.resultFiltros);
        if (filtroAvancado.tipoPlano.length) {
            this.queryTipoPlano = this.categoriaPlanoService.cleanCategoriaDescricao(this.resultFiltros.tipoPlano.itens[0].descricao);
            query.tipoPlano = this.queryTipoPlano;
            this.filtro.tipoPlano = this.loadFilterTipoPlano();
        } else {
            delete query.tipoPlano;
        }
        if (filtroAvancado.regimeAlimentacao.length && filtroAvancado.regimesAlimentacao.length) {
            this.queryRegimeAlimentacao = this.resultFiltros.regimesAlimentacao.itens[0].id;
            query.regimeAlimentacao = this.queryRegimeAlimentacao;
            this.filtro.regimesAlimentacao = this.loadFilterRegimeAlimentacao();
            this.filtro.regimeAlimentacao = this.loadFilterRegimeAlimentacao();
        } else {
            delete query.regimeAlimentacao;
        }
        if (filtroAvancado.tipoHotel.length) {
            this.queryTipoHotel = this.resultFiltros.tipoHotel.itens[0].descricao.toUpperCase();
            query.tipoHotel = this.queryTipoHotel;
            this.filtro.tipoHotel = this.loadFilterTipoHotel();
        } else {
            delete query.tipoHotel;
        }
        if (filtroAvancado.tipoQuarto.length) {
            this.queryTipoQuarto = this.removeBrackets(filtroAvancado.tipoQuarto);
            query.tipoQuarto = this.queryTipoQuarto;
            this.filtro.tipoQuarto = filtroAvancado.tipoQuarto;
        } else {
            delete query.tipoQuarto;
        }
        if (filtroAvancado.hotel.length) {
            this.queryHotel = this.resultFiltros.hotel.itens[0].descricao.toUpperCase();
            query.hotel = this.queryHotel;
            this.filtro.hotel = filtroAvancado.hotel;
        } else {
            delete query.hotel;
        }
        if (filtroAvancado.criancaGratis.length) {
            this.queryCriancaGratis = 'SIM';
            query.criancaGratis = this.queryCriancaGratis;
            this.filtro.criancaGratis = filtroAvancado.criancaGratis;
        } else {
            delete query.criancaGratis;
        }
        if (query) {
            const params = this.convertQueryParams(query);
            const url = `${this.route.snapshot.url[0].path}?${params}`;
            window.history.replaceState(null, null, url);
        }
    }
    removeBrackets(value: any) {
        return value.toString().replace('[', '').replace(']', '');
    }

    cleanFilter(data) {
        const filtersLabel = [
            'criancaGratis',
            'bairro',
            'cidade',
            'estado',
            'regimesAlimentacao',
            'tipoApartamento',
            'tipoQuarto',
            'hotel',
            'tipoHotel',
            'tipoPlano',
            'comodidades',
        ];
        filtersLabel.map(label => {
            if (data[label] && label !== 'tipoPlano' && label !== 'comodidades') {
                data[label].itens = [];
                data[label].quantidade = 0;
            }
            if (label === 'tipoPlano') {
                data[label].descricao = 'Categoria do Hotel';
            }
            if (label === 'comodidades') {
                data[label] = [];
            }
        });
        return data;
    }
    async loadHoteisPorAutoComplete() {
        this.appComponent.showOverlay();
        this.paginaAtual = 1;
        this.filtro = this.loadQueryFiltroAutoComplete();
        const result = await this.hotelService.filtroAvancado(this.filtro);
        this.resultFiltros = this.cleanFilter(result.data);
        this.resultHoteis = await this.hotelService.listaHoteis(this.filtro);
        this.resultHoteisSite();
        this.carregaPaginacao();
        this.appComponent.hideOverlay();
    }

    async loadFiltrosTratados() {
        if (!this.filtro) {
            this.filtro = { numeroPagina: 1, qtdPorPagina: this.qtdPorPagina };
            this.filtro.numeroPagina = 1;
        }
        const filtrosTratados = this.hotelService.getFiltroAvancado(this.filtro, this.resultFiltros);
        const result = await this.hotelService.filtroAvancado(filtrosTratados);
        if (result.data.criancaGratis) {
            result.data.criancaGratis.itens.forEach(resultado => {
                filtrosTratados.criancaGratis.forEach(filtroAnterior => {
                    if (resultado.id === filtroAnterior) {
                        resultado.checked = true;
                    }
                });
            });
        }
        if (result.data.hotel) {
            result.data.hotel.itens.forEach(resultado => {
                filtrosTratados.hotel.forEach(filtroAnterior => {
                    if (resultado.id === filtroAnterior) {
                        resultado.checked = true;
                    }
                });
            });
        }
        if (result.data.tipoPlano) {
            result.data.tipoPlano.itens.forEach(resultado => {
                filtrosTratados.tipoPlano.forEach(filtroAnterior => {
                    if (resultado.id === filtroAnterior) {
                        resultado.checked = true;
                    }
                });
            });
        }
        if (result.data.tipoHotel) {
            result.data.tipoHotel.itens.forEach(resultado => {
                filtrosTratados.tipoHotel.forEach(filtroAnterior => {
                    if (resultado.id === filtroAnterior) {
                        resultado.checked = true;
                    }
                });
            });
        }
        if (result.data.tipoApartamento) {
            result.data.tipoApartamento.itens.forEach(resultado => {
                filtrosTratados.tipoApartamento.forEach(filtroAnterior => {
                    if (resultado.id === filtroAnterior) {
                        resultado.checked = true;
                    }
                });
            });
        }
        if (result.data.tipoQuarto) {
            result.data.tipoQuarto.itens.forEach(resultado => {
                filtrosTratados.tipoQuarto.forEach(filtroAnterior => {
                    if (resultado.id === filtroAnterior) {
                        resultado.checked = true;
                    }
                });
            });
        }
        if (result.data.regimesAlimentacao) {
            result.data.regimesAlimentacao.itens.forEach(resultado => {
                filtrosTratados.regimesAlimentacao.forEach(filtroAnterior => {
                    if (resultado.id === filtroAnterior) {
                        resultado.checked = true;
                    }
                });
            });
        }
        if (result.data.comodidades) {
            result.data.comodidades.forEach(item => {
                item.comodidades.forEach(subitem => {
                    filtrosTratados.tipoComodidade.forEach(filtroAnterior => {
                        if (subitem.id.toString() === filtroAnterior) {
                            subitem.checked = true;
                        }
                    });
                });
            });
        }
        if (result.data.bairro) {
            result.data.bairro.itens.forEach(resultado => {
                if (resultado.descricao === filtrosTratados.bairro) {
                    resultado.checked = true;
                }
            });
        }
        return { result, filtrosTratados};
    }

    async loadHoteisPorTipoComodidade(tipoComodidade: number) {
        this.appComponent.showOverlay();
        this.paginaAtual = 1;
        this.filtro = this.loadQueryFiltro({ numeroPagina: 1, qtdPorPagina: this.qtdPorPagina, tipoComodidade: [tipoComodidade] });
        const result = await this.hotelService.filtroAvancado(this.filtro);
        this.resultFiltros = this.cleanFilter(result.data);
        this.resultHoteis = await this.hotelService.listaHoteis(this.filtro);
        this.resultHoteisSite();
        this.carregaPaginacao();
        this.appComponent.hideOverlay();
    }

    async loadHoteisPorTipoApartamento(tipos: any[]) {
        this.appComponent.showOverlay();
        this.paginaAtual = 1;
        this.filtro = this.loadQueryFiltro( { numeroPagina: 1, qtdPorPagina: this.qtdPorPagina, tipoApartamento: tipos });
        const result = await this.hotelService.filtroAvancado(this.filtro);
        this.resultFiltros = this.cleanFilter(result.data);
        this.resultHoteis = await this.hotelService.listaHoteis(this.filtro);
        this.resultHoteisSite();
        this.carregaPaginacao();
        this.appComponent.hideOverlay();
    }

    carregaPaginacao() {
        this.paginacao = [];
        if (this.resultHoteis !== null ) {
            if (this.resultHoteis.data) {
                if (this.paginaAtual === 1 && this.resultHoteis.data.totalPaginas >= 6) {
                    this.inicioPaginacao = 1;
                    this.fimPaginacao = 6;
                } else {
                    this.inicioPaginacao = 1;
                    this.fimPaginacao = this.resultHoteis.data.totalPaginas;
                }

                if (this.paginaAtual > 6) {
                    this.inicioPaginacao = this.paginaAtual;
                    this.fimPaginacao = this.inicioPaginacao + 5;
                } else if ((this.inicioPaginacao + 5) < this.resultHoteis.data.totalPaginas) {
                    this.inicioPaginacao = 1;
                    this.fimPaginacao = this.inicioPaginacao + 5;
                } else {
                    this.inicioPaginacao = 1;
                    this.fimPaginacao = this.resultHoteis.data.totalPaginas;
                }

                if (this.fimPaginacao > this.resultHoteis.data.totalPaginas) {
                    this.inicioPaginacao = this.fimPaginacao - 5;
                    this.fimPaginacao = this.resultHoteis.data.totalPaginas;
                }

                if ((this.fimPaginacao - this.inicioPaginacao) < 6) {
                    this.inicioPaginacao = this.fimPaginacao - 5;
                }

                if (this.inicioPaginacao < 1) {
                    this.inicioPaginacao = 1;
                }

                for (let index = this.inicioPaginacao; index <= this.fimPaginacao; index++) {
                    this.paginacao.push({ numeroPagina: index, qtdPorPagina: this.resultHoteis.data.qtdPorPagina });
                }
            }
        }
    }

    async loadHoteisPorPaginacao(paginaAtual: number) {
        this.appComponent.showOverlay();
        this.paginaAtual = paginaAtual;
        if (!this.filtro) {
            this.filtro = { numeroPagina: paginaAtual, qtdPorPagina: this.resultHoteis.data.qtdPorPagina };
        } else {
            this.filtro.numeroPagina = paginaAtual;
        }
        const result = await this.hotelService.filtroAvancado(this.filtro);
        this.resultFiltros = this.cleanFilter(result.data);
        this.resultFiltros = this.tratarFiltro(this.resultFiltros);
        this.resultHoteis = await this.hotelService.listaHoteisAvancado(this.filtro, this.resultFiltros);
        this.resultHoteisSite();
        this.carregaPaginacao();
        this.appComponent.hideOverlay();
        this.scroll('oquevocedeseja');
    }

    async proximoGrupoPaginacao() {
        if (this.paginaAtual === this.resultHoteis.data.totalPaginas) {
            return;
        }
        if (this.fimPaginacao === 1) {
            return;
        }
        this.paginaAtual = this.paginaAtual + 1;
        this.inicioPaginacao = this.paginaAtual;
        this.fimPaginacao = this.inicioPaginacao + 5;
        if (this.fimPaginacao > this.resultHoteis.data.totalPaginas) {
            this.fimPaginacao = this.resultHoteis.data.totalPaginas;
        }
        await this.loadHoteisPorPaginacao(this.paginaAtual);
    }

    async anteriorGrupoPaginacao() {
        if (this.paginaAtual === 1) {
            return;
        }
        this.paginaAtual = this.paginaAtual - 1;
        this.fimPaginacao = this.paginaAtual;
        this.inicioPaginacao = this.paginaAtual - 5;
        if (this.inicioPaginacao < 1) {
            this.inicioPaginacao = 1;
        }
        await this.loadHoteisPorPaginacao(this.paginaAtual);
    }

    navegarParaDetalheHotel(item): void {
        const param = item.codContrato + '_' + item.slug;
        const url = this.router.serializeUrl(this.router.createUrlTree([`/hoteis/hotel/${param}`]));
        window.open(url, '_blank');
    }

    scroll(el) {
        const yOffset = -150;
        const element = document.getElementById(el);
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: 'smooth' });
    }

    loadHoteisLuxo() {
        const arrayHoteis: any[] = [];
        arrayHoteis.push(3);
        arrayHoteis.push(14);
        this.loadHoteisPorTipoApartamento(arrayHoteis);
    }

    loadAtalhoHoteisPorTipoComodidade(tipo) {
        if (tipo === 19) {
            this.loadHoteisPorTipoComodidade(19);
        } else if (tipo === 23) {
            this.loadHoteisPorTipoComodidade(23);
        } else if (tipo === 24) {
            this.loadHoteisPorTipoComodidade(24);
        }
    }

    onShowFilter(show: boolean = false) {
        if (this.isMobile) {
            if (show) {
                this.showFilter = !this.showFilter;
            }
            return this.showFilter;
        }
        return true;
    }
    private convertQueryParams(query: any) {
        let params = JSON.stringify(query);
        params = params.replace(/[\\"]/g, '');
        params = params.replace(/[\\:]/g, '=');
        params = params.replace(/[\\,]/g, '&');
        params = params.replace('{', '');
        params = params.replace('}', '');
        return params;
    }

    convertArray(resultFiltros: FiltroHotel) {
        return Object.entries(resultFiltros);
    }

    stringify(item: any) {
        return JSON.stringify(item);
    }

    isFilterValid(item: any): boolean {
        return !(item[0] === 'comodidades' || item[1].descricao === null || item[1].descricao === undefined);
    }
}
